export const dataServiceList = [
    {
        id: 1,
        title: 'TREATMENTS',
        description: `Full-body spa treatments are ideal for targeting multiple areas and providing overall relaxation. Whether you're looking to detox, improve your overall skin appearance, or simply unwind, these body spa services deserve a spot on your spa bucket list!`,
        service1: 'SWEDISH MASSAGE',
        price1: 320,
        service2: 'BROWN SUGER SCRUB',
        price2: 290,
        service3: 'SALT BODY SCRUB',
        price3: 360,
        img1: 'treatment-3',
        img2: 'treatment-1',
        img3: 'treatment-2',
        img4: 'salt-body-scrub',
        img5: 'brown-sugar-scrub',
        img6: 'treatment-4'
    },
    {
        id: 2,
        title: 'THERMAL BATH',
        description: `Thermal baths are pools of water with mineral properties at various extreme temperatures that aim to recalibrate your body, relax your mind and recharge your spirit. To define the therapeutic action of a bath, two important qualities are considered: temperature and chemical composition of the water. `,
        service1: 'EXFOLIATION',
        price1: 250,
        service2: 'RELAXING SAUNA',
        price2: 300,
        service3: 'POWDER',
        price3: 365,
        img1: 'bath',
        img2: 'bath-2',
        img3: 'bath-3',
        img4: 'exfoliation',
        img5: 'bath-5',
        img6: 'bath-6'
    },
    {
        id: 3,
        title: 'MASSAGES',
        description: `While massage techniques are incredibly relaxing, they're much more than that! Massages offer various wellness benefits, including pain relief, reduced stress and anxiety, improved posture, and relaxed muscles.`,
        service1: 'BODY BRUSHING',
        price1: 345,
        service2: 'JADE FACE ROLLER',
        price2: 335,
        service3: 'CAVIAR LIFT',
        price3: 390,
        img1: 'body-brushing',
        img2: 'massage-2',
        img3: 'massage-3',
        img4: 'massage-4',
        img5: 'caviar-lift',
        img6: 'swedish-massage'
    },
    {
        id: 4,
        title: 'AROMATIC OILS',
        description: `During an aromatherapy massage, your massage therapist will provide a body massage using aromatic oils that contain specific healing properties. Various oils can provide benefits such as stress relief, reduced muscle tension, relaxation, and more.`,
        service1: 'OIL PEELING',
        price1: 250,
        service2: 'LIFTING SERUM',
        price2: 370,
        img1: 'oil-1',
        img2: 'oil-2',
        img3: 'oil-3',
        img4: 'oil-4',
        img5: 'oil-5',
        img6: 'oil-6'
    }
]